import { COPY_PROPERTY, VIEW_PROPERTY, EDIT_PROPERTY, ADD_PROPERTY, ENABLE_COPY, GET_STEP_ONE_DATA, GET_FLOOR_DATA, SET_PROPERTY_ID, STEP1_SAVED, STEP2_SAVED, STEP3_SAVED, CLEAR_FLOOR_DATA } from './types'

const initialState = {
    isEnableCopy: true,
    floorData: [],
    stepOneData: "",
    propertyID: "",
    step1_Saved:false,
    step2_Saved:false,
    step3_Saved:false,
};

const propertiesReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ENABLE_COPY:
            return {
                ...state,
                ...payload
            }
        case GET_STEP_ONE_DATA:
            return {
                ...state,
                ...payload
            }
        case GET_FLOOR_DATA:
            return {
                ...state,
                ...payload
            }
        case SET_PROPERTY_ID:
            return {
                ...state,
                ...payload
            }
        case COPY_PROPERTY:
            return {
                ...state,
                propertyDetails: payload,
                formMode:type
            };
        case VIEW_PROPERTY:
            return {
                ...state,
                propertyDetails: payload,
                formMode: type
            };
        case EDIT_PROPERTY:
            return {
                ...state,
                propertyDetails: payload,
                formMode: type
            };
        case ADD_PROPERTY:
            return {
                ...state,
                propertyDetails: null,
                formMode: type
            };
        case STEP1_SAVED:
            return {
                ...state,
                step1_Saved: payload
            };
        case STEP2_SAVED:
            return {
                ...state,
                step2_Saved: payload
            };
        case STEP3_SAVED:
            return {
                ...state,
                step3_Saved: payload
            };
        case CLEAR_FLOOR_DATA:
            return {
                ...state,
                floorData: []
            };
        default:
            return state;
    }
}
export default propertiesReducer